import { ENTITY_ADD_REQUEST_STATUSES } from '../../types/entity_add_requests';

// Which modal the `/requestsToAdd/overview/suppliers/:id` deep link should open. The link is the
// "View Request" button on the EntityRequestStatusChange emails, so it always resolves to a modal —
// unlike the row actions, which fall through to edit/delete for a requester's own open request.
export const ENTITY_ADD_REQUEST_DEEP_LINK_TARGETS = {
	review: 'review',
	view: 'view',
};

// An approver following the "waiting for your approval" email gets the actionable Review modal;
// everyone else (the requester on approve/reject, or an approver on an already-decided request)
// gets the read-only View modal.
export const getEntityAddRequestDeepLinkTarget = (record, canApprove) =>
	canApprove && record && record.status === ENTITY_ADD_REQUEST_STATUSES.pending_review
		? ENTITY_ADD_REQUEST_DEEP_LINK_TARGETS.review
		: ENTITY_ADD_REQUEST_DEEP_LINK_TARGETS.view;

export const getRequestsToAddSuppliersListPath = (userType) =>
	`/${userType}/requestsToAdd/overview/suppliers`;
